<template>
     <new-services-modal  @onFire="eventOpenModal_" :step="data_.step" v-bind:debtorCaseId="data_.debtorCaseId" />
</template>

<script lang="ts">
import axios from 'axios'
import {reactive, onMounted} from 'vue';
import NewServicesModal from '@/components/Service/NewServicesModal.vue'

import { getClietIdSession, getToken, getFormatDateComplete } from '@/api/global'
import * as global from "@/api/global";

export default {
  name: 'Service',
  components: { NewServicesModal },
  setup() {
    const data_ = reactive({
      step: 1,
      openModal: false,
      debtorCaseId: 0,
      openModalActivity: false,
      openModalComment: false,
    });

    let data = reactive([{
      id: 16691464,
      internalReference: "1",
      createDate: "2022-02-22T19:23:18.155",
      clientReference: "2022-022222",
      importDate: "2022-02-22T19:23:18.153",
      endDate: null,
      phaseTypeId: 1,
      situationTypeId: "V",
      creationDate: "2022-02-22T19:23:18.155",
      lastUpdateDate: "2022-02-22T19:23:18.31"
    }]);

    let errors = reactive([{
      code: 16691464,
      msg: "1"
    }]);

    const eventOpenModal_ = (id: number) => {
      data_.openModal = !data_.openModal;
      data_.debtorCaseId = id;
    };

    const eventOpenModal_activity = () => {
      data_.openModalActivity = !data_.openModalActivity;
    };

    const eventOpenModal_comment = () => {
      data_.openModalComment = !data_.openModalComment;
    };

    const getDebts = async () => {
      const url = process.env.VUE_APP_BASE_URL + `/Client/${getClietIdSession()}/debtorcases`;
      let response = null;
      try {
        response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        });
      } catch (e: any) {
        response = e.response;
      }

      if (response.status == 200) {
        data = response.data;
      } else {
        if (response.status == 401) {
          global.logout();
        }
        errors = response.data;
      }
      return response.data;
    };

    onMounted(() => {
      getDebts();
    });

    return {
      eventOpenModal_,
      eventOpenModal_activity,
      eventOpenModal_comment,
      data_,
      data,
      errors,
      getDebts,
      getFormatDateComplete
    };
  }
};

</script>
